import React from 'react';
import PropTypes from 'prop-types';
import Button from '@/components/elements/button';

function LocaleMismatchModal({ title, bodyText, suggestedLabel, currentLabel, onSelectSuggested, onDismiss }) {
	return (
		<div className="flex flex-col gap-6">
			<div className="flex flex-col gap-4">
				<h2 className="text-headline-medium text-midnight pr-8">{title}</h2>

				<p className="text-base leading-6 text-shuttle-grey">{bodyText}</p>

				<div className="flex gap-4 items-start">
					<Button buttonType="PRIMARY" text={suggestedLabel} onClick={onSelectSuggested} />
					<Button buttonType="SECONDARY_MARINER" text={currentLabel} onClick={onDismiss} />
				</div>
			</div>
		</div>
	);
}

LocaleMismatchModal.propTypes = {
	title: PropTypes.string.isRequired,
	bodyText: PropTypes.string.isRequired,
	suggestedLabel: PropTypes.string.isRequired,
	currentLabel: PropTypes.string.isRequired,
	onSelectSuggested: PropTypes.func.isRequired,
	onDismiss: PropTypes.func.isRequired,
};

export default LocaleMismatchModal;
